import { render, staticRenderFns } from "./MyArticle.vue?vue&type=template&id=5dae4fb4"
import script from "./MyArticle.vue?vue&type=script&lang=js"
export * from "./MyArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports